export default __webpack_public_path__ + "static/media/medalha-diamante.1b2b0043.svg";